<div
  class="tab-bar"
  *appI18nScopeReady
  cdkDropList
  cdkDropListOrientation="horizontal"
  (cdkDropListDropped)="drop($event)"
>
  @for (tab of tabs(); track tab.id) {
    <div
      class="tab-bar__tab"
      cdkDrag
      [cdkDragData]="tab"
      [class.tab-bar__tab--active]="tab.id === activeTabId()"
      [tabindex]="0"
      (click)="activate(tab.id)"
      (keydown.enter)="activate(tab.id)"
    >
      <span class="tab-bar__title">{{ tab.title }}</span>
      <button
        type="button"
        class="tab-bar__close"
        [attr.aria-label]="'tab_bar_close_tab_tooltip' | i18n"
        [matTooltip]="'tab_bar_close_tab_tooltip' | i18n"
        (click)="close(tab.id, $event)"
      >
        <mat-icon class="tab-bar__close-icon">close</mat-icon>
      </button>
    </div>
  }
</div>
